export class ResponseUnidadEducativaModel{
    payload:UnidadEducativaModel;

    constructor(){
        this.payload = new UnidadEducativaModel();
    }
}

export class ResponseUnidadEducativaProyectoModel{
    payload:UnidadEducativaProyectoModel;

    constructor(){
        this.payload = new UnidadEducativaProyectoModel();
    }
}


export class UnidadEducativaProyectoModel{
    idJardinPeriodo:number;
    nombreInstitucion:string;
    sitioWebInstitucion:string;
    direccionInstitucion:string;
    nombreUnidadEducativa:string;
    codigoUnidadEducativa:string;
    directoraUnidadEducativa:string;
    correoUnidadEducativa:string;
    telefonoUnidadEducativa:string;
    direccionUnidadEducativa:string;
    comunaUnidadEducativa:string;
    regionUnidadEducativa:string;

    constructor(){
        this.idJardinPeriodo = 0;
        this.nombreInstitucion = '';
        this.sitioWebInstitucion = '';
        this.direccionInstitucion = '';
        this.nombreUnidadEducativa = '';
        this.codigoUnidadEducativa = '';
        this.directoraUnidadEducativa = '';
        this.correoUnidadEducativa = '';
        this.telefonoUnidadEducativa = '';
        this.direccionUnidadEducativa = '';
        this.comunaUnidadEducativa = '';
        this.regionUnidadEducativa = '';

    }
}

export class UnidadEducativaModel{
    rbd:string;
    nombreJardin:string;
    programa:string;
    modalidad:string;
    telefono:string;
    direccion:string;
    comuna:string;
    region:string;

    constructor(){
        this.rbd = '';
        this.nombreJardin = '';
        this.programa = '';
        this.modalidad = '';
        this.telefono = '';
        this.direccion = '';
        this.comuna = '';
        this.region = '';
    }
}

export class ResponseEncargadaModel{
    payload:EncargadaModel;

    constructor(){
        this.payload = new EncargadaModel();
    }
}
export class EncargadaModel{
    correo:string;
    correoParticular:string;
    nombreDirectora:string;
    telefono:string;
 

    constructor(){
        this.correo = '';
        this.correoParticular = '';
        this.nombreDirectora = '';
        this.telefono = '';
 
    }
}

export class ResponseEquipoPedagogicoModel{
    payload:EquipoPedagogicoModel[];

    constructor(){
        this.payload = new Array<EquipoPedagogicoModel>();
    }
}

export class EquipoPedagogicoModel{
    
    idPersona:number;
    rut:string;
    nombres:string;
    apellido:string
    correoParticular:string;
    telefono:string
    estamento:EstamentoModel;
    usuario:string
    clave:string

    constructor(){
        this.idPersona = 0;
        this.rut = null;
        this.nombres = '';
        this.apellido = '';
        this.correoParticular = '';
        this.telefono = '';
        this.estamento = new EstamentoModel();
        this.usuario = '';
        this.clave = '';
 
    }
}

export class ResponseEstamentoModel{
    payload:EstamentoModel[];

    constructor(){
        this.payload = new Array<EstamentoModel>();
    }
}

export class EstamentoModel{
    
    idTablaMaestra:number;
    discriminador:number;
    descripcionCorta:string;
    descripcionLarga:string
    agrupador:number;

    constructor(){
        this.idTablaMaestra = null;
        this.discriminador = 0;
        this.descripcionCorta = '';
        this.descripcionLarga = '';
        this.agrupador = 0; 
 
    }
}

 